export function readCsrfToken() {
  const match = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]*)/)

  if (match) {
    return decodeURIComponent(match[1])
  }

  return document.querySelector('meta[name="csrf-token"]')?.content ?? ''
}

export function syncCsrfTokenMeta() {
  const token = readCsrfToken()

  if (!token) {
    return null
  }

  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) {
    meta.content = token
  }

  const input = document.querySelector('input[name="_token"]')
  if (input) {
    input.value = token
  }

  return token
}
